import { Box, Typography, Table, TableHead, TableRow, TableCell, TableBody, Paper, LinearProgress } from '@mui/material';
import { useProjectTimeEntries, useProjectRollup } from '../../hooks/useProjects';
import { RollupCards, BarList } from './RollupCards';
import { formatHours, formatMoneyFull } from './constants';

export default function TimeTab({ projectId, scope }) {
  const { data: entries = [], isLoading } = useProjectTimeEntries(projectId, scope);
  const { data: rollup } = useProjectRollup(projectId, scope);

  return (
    <Box>
      <BarList
        title="Hours by person"
        rows={(rollup?.hours_by_person || []).map((r) => ({ label: r.person || '(unassigned)', value: r.hours }))}
        valueFormat={formatHours}
      />
      <Paper variant="outlined" sx={{ overflow: 'hidden' }}>
        <Box sx={{ p: 1.5, borderBottom: '1px solid', borderColor: 'divider', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="subtitle2">Time entries ({entries.length})</Typography>
          <Typography variant="caption" color="text.secondary">
            Total: {formatHours(rollup?.hours || 0)}
          </Typography>
        </Box>
        {isLoading && <LinearProgress />}
        {!isLoading && entries.length === 0 && (
          <Typography variant="body2" color="text.secondary" sx={{ p: 3, textAlign: 'center' }}>
            No time entries logged for this project yet. Add time via Payroll → Log Time and select this project.
          </Typography>
        )}
        {entries.length > 0 && (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>Person</TableCell>
                <TableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>Project</TableCell>
                <TableCell>Category</TableCell>
                <TableCell align="right">Hours</TableCell>
                <TableCell>Notes</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {entries.map((e) => (
                <TableRow key={e.id} hover>
                  <TableCell>{e.date ? String(e.date).slice(0, 10) : '—'}</TableCell>
                  <TableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>{e.person || '—'}</TableCell>
                  <TableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>{e.project_name || '—'}</TableCell>
                  <TableCell>{e.category || '—'}</TableCell>
                  <TableCell align="right" sx={{ fontVariantNumeric: 'tabular-nums' }}>{Number(e.hours || 0).toFixed(1)}</TableCell>
                  <TableCell sx={{ maxWidth: { xs: 'none', md: 280 }, whiteSpace: { xs: 'normal', md: 'nowrap' }, overflow: 'hidden', textOverflow: 'ellipsis' }}>{e.notes}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </Paper>
    </Box>
  );
}
